export default __webpack_public_path__ + "static/media/footer.4a8003c0.png";